module.exports = __webpack_public_path__ + "img/card-bg-yellow.b6e8d16.1e94fe98.png";